export const pricing = {
  pageHeader: {
    title: 'Je vergoeding',
  },
  pricingFeatures: {
    group1: {
      feature1: {
        label: 'Facturen, offertes, creditnota’s … opmaken',
      },
      feature2: {
        label: 'Auteursrechten 100% correct',
      },
      feature3: {
        label: 'Overzichtelijk dashboard',
      },
      feature4: {
        label: 'Een Community om op te rekenen',
      },
      title: 'Handig facturatieplatform',
    },
    group2: {
      feature1: {
        label: 'Roerende voorheffing doorstorten',
      },
      feature2: {
        label: 'Fiscale fiche opmaken',
      },
      feature3: {
        label: 'Contracten opstellen',
      },
      feature4: {
        label: 'Betalingsopvolging',
      },
      title: 'De administratie doen wij',
    },
    group3: {
      feature1: {
        label: 'Geen chatbots, maar mensen',
      },
      feature2: {
        label: 'Dubbelcheck van je facturen',
      },
      feature3: {
        label: 'Technische hulp',
      },
      feature4: {
        label: 'Advies in mensentaal',
      },
      title: 'Persoonlijke hulp',
    },
    title: 'Dit krijg je van ons',
  },
  pricingInfo: {
    commission: {
      details: {
        button: 'Details',
        commissionWithDiscount: 'Nieuwe vergoeding',
        commissionWithoutDiscount: 'Standaardvergoeding',
        freeTrial_one: '{{count}} dag gratis',
        freeTrial_other: '{{count}} dagen gratis',
        referralDiscount: 'Referral {{inviteeName}}',
      },
      deviations: {
        adminOverride: {
          explanation: 'Je vergoeding wijkt af van het standaardtarief.',
          label: 'Aangepaste vergoeding',
        },
        earlyAdopter: {
          label: 'Early adopter',
        },
        loyalUser: {
          label: 'Trouwe Shelteraar',
          tooltip:
            'Je bent er al even bij en daarom bedanken we je graag met een lagere vergoeding. Want nieuwe Shelteraars die zich aansluiten sinds 2025, betalen namelijk een vaste vergoeding van 8%.',
        },
        premiumForFree: {
          label_one: 'Nog {{count}} dag gratis',
          label_other: 'Nog {{count}} dagen gratis',
          tooltip: 'Geldig tot en met {{expirationDate}}',
        },
        referralDiscount: {
          label: 'Referral korting ({{amount}})',
        },
        yearlyCopyrightLimitExceeded: {
          explanation:
            'Je hebt je limiet van auteursrechten voor dit jaar overschreden. Al je prestaties zijn nu beroepsinkomsten, dus mag je gratis factureren tot het einde van het jaar.',
          label: 'Limiet auteursrechten bereikt',
        },
      },
      explanation: {
        subTitle: 'Enkel een vergoeding als je factureert.',
        text: 'Dit is wat Creative Shelter inhoudt op het totaalbedrag van je factuur (excl. btw), per creatieve prestatie. Je betaalt alleen als je factureert. Geen factuur? Geen kosten.',
        title: 'Geen abonnement.',
      },
      title: 'Vergoeding per factuur',
    },
  },
  pricingStats: {
    currentYear: {
      text: 'Voordeel dankzij Creative Shelter',
      title: 'Voordeel in {{year}}',
    },
    error: {
      title: 'Geen gegevens gevonden',
    },
    previousYear: {
      text: 'Totaal voordeel dankzij Creative Shelter',
      title: 'Totaal voordeel in {{year}}',
    },
  },
};
